export const PIXEL_ID = '1225428543097695'
export const CHECKOUT_URL = 'https://pay.hotmart.com/R105990585T'
export const COUNTDOWN_SECONDS = 643 // 10 min 43 sec

export const IMAGES = {
  tomo1:
    'https://cdn.magicpatterns.com/uploads/2sCbJWLWJFhdazrpHrk8XR/tomo_1.png',
  tomo2:
    'https://cdn.magicpatterns.com/uploads/oj9AEjU2g6DQwRsczu86TD/tomo_2.png',
  tomo3:
    'https://cdn.magicpatterns.com/uploads/vjCeN8uFBzeZaC1qqLDve3/tomo_3.png',
  tomo4:
    'https://cdn.magicpatterns.com/uploads/mZi2UAYt52mk9q1RaC8ZHm/tomo_4.png',
  tomo5:
    'https://cdn.magicpatterns.com/uploads/t6LVejYGM3SDSSZHbnds8n/tomo_5.png',
}

export const PRICES = {
  original: '79,99 \u20AC',
  sale: '14,99 \u20AC',
  totalValue: '130,95 \u20AC',
  savings: '81%',
}

export const PRODUCT_ITEMS = [
  {
    title: 'Fondamenti del Tango e Struttura della Lezione',
    description: `Una guida pratica per costruire lezioni di tango chiare, professionali ed efficaci fin dalla prima classe.`,
  },
  {
    title: 'Tecnica e Progressione Didattica',
    description: `Un metodo concreto per insegnare tecnica, postura, connessione e progressione in modo ordinato e comprensibile.`,
  },
  {
    title: 'Sequenze e Dinamiche di Classe',
    description: `Idee pratiche e strutture di lezione per rendere ogni classe più fluida, coinvolgente e memorabile.`,
  },
  {
    title: `Musicalità e Interpretazione nel Tango`,
    description: `Strategie semplici per aiutare gli allievi a sentire la musica, interpretarla meglio e ballare con maggiore consapevolezza.`,
  },
  {
    title: 'Gestione della Classe e degli Studenti',
    description: `La risorsa completa per gestire gruppi, livelli diversi, difficoltà comuni e migliorare l\u2019esperienza generale dei tuoi allievi.`,
  },
]

export const BONUS_ITEMS = [
  {
    title: 'Pianificatore Express \u201CLezione in 10 Minuti\u201D',
    description: `Prepara la tua prossima lezione di tango in soli 10 minuti, con tutto pronto in anticipo. Niente più domeniche sera a cercare cosa insegnare.`,
    value: '14,99 \u20AC',
  },
  {
    title: 'Banca di Aperture e Chiusure',
    description: `Aperture che agganciano l\u2019allievo dal primo minuto e chiusure che lo lasciano con voglia di tornare la lezione successiva.`,
    value: '12,99 \u20AC',
  },
  {
    title: 'Rotazioni Perfette',
    description: `Diagrammi e script per gestire qualsiasi combinazione di allievi: numeri pari, dispari, misti o con differenze di livello, senza mai lasciare nessuno fuori.`,
    value: '14,99 \u20AC',
  },
  {
    title: 'Kit di Valutazione + Certificati',
    description: `Test per livello, rubriche di valutazione e certificati stampabili per dimostrare i progressi dei tuoi allievi e dare valore al tuo lavoro.`,
    value: '17,99 \u20AC',
  },
  {
    title: 'Playlist Pedagogica TangoPack',
    description: `La musica giusta nel momento giusto, con l\u2019obiettivo giusto. Playlist pronte all\u2019uso per ogni fase della lezione.`,
    value: '9,99 \u20AC',
  },
  {
    title: 'Kit Stampabile di Schede di Lezione',
    description: `Materiale fisico professionale che l\u2019allievo porta via dopo ogni lezione e che parla di te come insegnante anche quando non sei presente.`,
    value: '12,99 \u20AC',
  },
]

export const TESTIMONIALS = [
  {
    name: 'Giulia',
    age: 34,
    city: 'Milano',
    review: `Finalmente ho una struttura chiara per le mie lezioni di tango. I miei studenti sono più coinvolti e anch\u2019io mi sento molto più sicura quando insegno.`,
  },
  {
    name: 'Marco',
    age: 41,
    city: 'Roma',
    review: `Questo pack mi ha aiutato a rendere le lezioni molto più dinamiche. Gli studenti partecipano di più e noto progressi più rapidi.`,
  },
  {
    name: 'Elena',
    age: 29,
    city: 'Torino',
    review: `Prima improvvisavo spesso. Adesso ho un metodo semplice da seguire e le lezioni risultano molto più professionali.`,
  },
  {
    name: 'Davide',
    age: 46,
    city: 'Napoli',
    review: `Ho trovato idee pratiche, immediate e davvero utili. Consigliatissimo a chi insegna tango e vuole fare un salto di qualità.`,
  },
  {
    name: 'Francesca',
    age: 38,
    city: 'Bologna',
    review: `Una risorsa completa e ben fatta. Mi ha aiutata tantissimo a motivare meglio i miei studenti e a organizzare tutto con più chiarezza.`,
  },
]

export const FAQS = [
  {
    question: `Questo prodotto è adatto a qualsiasi insegnante di tango?`,
    answer: `Sì, il Metodo Completo è pensato per insegnanti di tango che lavorano con principianti, intermedi o gruppi misti e che vogliono dare più struttura alle proprie lezioni.`,
  },
  {
    question: `Riceverò accesso immediato dopo l\u2019acquisto?`,
    answer: `Sì, subito dopo il pagamento riceverai accesso immediato a tutto il materiale digitale.`,
  },
  {
    question: 'Devo avere esperienza pedagogica per applicarlo?',
    answer: `No, il materiale è stato pensato per essere semplice, pratico e utilizzabile anche da chi non ha una formazione pedagogica avanzata.`,
  },
  {
    question: `Il pagamento è unico?`,
    answer: `Sì, paghi una sola volta. Non ci sono abbonamenti né costi nascosti.`,
  },
  {
    question: `È prevista una garanzia?`,
    answer: `Sì, hai una garanzia di 45 giorni per acquistare in totale tranquillità.`,
  },
]

export const BUYER_NAMES = [
  { name: 'Luca', city: 'Firenze' },
  { name: 'Martina', city: 'Verona' },
  { name: 'Alessio', city: 'Palermo' },
  { name: 'Serena', city: 'Bari' },
  { name: 'Andrea', city: 'Genova' },
  { name: 'Chiara', city: 'Padova' },
  { name: 'Matteo', city: 'Catania' },
  { name: 'Silvia', city: 'Parma' },
  { name: 'Federico', city: 'Perugia' },
  { name: 'Valentina', city: 'Trieste' },
  { name: 'Paolo', city: 'Modena' },
  { name: 'Laura', city: 'Venezia' },
]
